import React from "react";
class User{
    constructor(UserID, Password) {
      this.UserID = UserID;
      this.Password = Password;
    }
  }

  export default User;
